import { render, staticRenderFns } from "./bindings.vue?vue&type=template&id=77fa80ca&scoped=true"
import script from "./bindings.vue?vue&type=script&lang=js"
export * from "./bindings.vue?vue&type=script&lang=js"
import style0 from "./bindings.vue?vue&type=style&index=0&id=77fa80ca&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77fa80ca",
  null
  
)

export default component.exports